import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { ToastrTypes } from '@app/entities/toastr';
import { BOOKING_FORM_INPUTS } from '@booking/constants/forms.constants';
import { FormInputType, FormDocumentInputTemplate } from '@forms/form-text-input/entities/input-type';
import { MarriottCreateFormUIResponse } from '@pax/entities/marriott-create-form';
import { MarriottEnrollmentResponse } from '@pax/entities/loyalty-program.response';
import { FormValidationService } from '@reservation/services/form-validation.service';

@Component({
  selector: 'app-marriott-bonvoy-create-form',
  templateUrl: './marriott-bonvoy-create-form.component.html',
  styleUrls: ['./marriott-bonvoy-create-form.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MarriottBonvoyCreateFormComponent implements OnInit {

  @Input() marriottCreatedAccount: MarriottEnrollmentResponse;
  @Input() defaultEmailValue: string;
  @Input() isLoadingMarriottCreateForm: boolean;
  @Input() marriottCreateAccountShowStatus: MarriottCreateFormUIResponse;

  @Output() createMarriottBonvoyAccount: EventEmitter<string> = new EventEmitter<string>();
  @Output() updateMarriottBonvoyNumber: EventEmitter<string> = new EventEmitter<string>();
  @Output() resetMarriottCreateAccountShowStatus: EventEmitter<void> = new EventEmitter<void>();

  public marriottCreateForm: UntypedFormGroup;
  public flyerSelector: string = BOOKING_FORM_INPUTS.EMAIL;
  public isSubmitted = false;
  public documentInput: FormInputType = FormInputType.EMAIL;
  public alphanumericType: FormDocumentInputTemplate = FormDocumentInputTemplate.ALPHANUMERIC;

  constructor(
    private readonly formValidationService: FormValidationService,
  ) { }

  ngOnInit(): void {
    this.createMarriottCreateForm();
  }

  get showErrorSuccessBox(): boolean {
    return this.marriottCreateAccountShowStatus?.showStatus;
  }

  get isSuccessStatus(): boolean {
    return this.marriottCreateAccountShowStatus?.status === ToastrTypes.SUCCESS;
  }

  public createMarriottCreateForm(): void {
    this.marriottCreateForm = new UntypedFormGroup({
      [BOOKING_FORM_INPUTS.EMAIL]: new UntypedFormControl(this.defaultEmailValue, [Validators.required, Validators.minLength(3)]),
    });
  }

  public createAcount(): void {
    this.isSubmitted = true;
    if (!this.formValidationService.formInvalidControls(this.marriottCreateForm)) {
      const values = this.marriottCreateForm.value;
      this.createMarriottBonvoyAccount.emit(values[BOOKING_FORM_INPUTS.EMAIL])
    }
  }

  public saveBonvoyNumber(): void {
    this.updateMarriottBonvoyNumber.emit(this.marriottCreatedAccount?.rewardsNumber);
  }

  public resetForm(): void {
    this.resetMarriottCreateAccountShowStatus.emit();
  }

}
